export default {
	data () {
		return {
			images: {
				serverId: [],
				localId: [],
				urls: []
			}
		}
	},
    methods: {
    	setWxShare(title,img,desc,link){
    		link = link || window.location.href
    		
            let sub_host = this.$store.state.user.info?this.$store.state.user.info.x_sub_host:''
            
            if(process.env.NODE_ENV === 'production'){
                link = link.replace('base.','')
            }
    		
    		if(link.indexOf(sub_host)==-1){
    			link = link.replace('//','//'+sub_host+'.')
            }

            if(sub_host != '' && link.indexOf('hzs.') != -1){
                link = link.replace('hzs.','')
            }
            
            return new Promise((resolve,reject)=>{
                this.$store.dispatch('getJssdkConfig',this.$wechat)
                .then(jssdk=>{
                   let funcs =  ['onMenuShareAppMessage','onMenuShareTimeline','onMenuShareQQ','onMenuShareWeibo']
                   let share_data = {}
                   share_data.title = title
                   share_data.link  = link || window.location.href
                   share_data.imgUrl = img
                   share_data.desc   = desc||''
                   share_data.success = function(){
                    resolve()
                   }
                   share_data.cancel = function(){
                    reject()
                   }
                   //config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
               	   //https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421141115
                   this.$wechat.ready(()=>{
	                   funcs.forEach((func,i)=>{
	                    this.$wechat[func](share_data)
	                   })
                   })
                })
            })
       },       
       chooseWXPay (data) {
       		return new Promise((resolve,reject)=>{
       			this.$store.dispatch('getJssdkConfig',this.$wechat)
       			.then(jssdk=>{
       				this.$wechat.chooseWXPay({
       					timestamp: data.timeStamp,
					    nonceStr: data.nonceStr,
					    package: data.package,
					    signType: data.signType,
					    paySign: data.paySign,
					    success: function (res) {
					    	resolve()
					        // 支付成功后的回调函数
					        console.log('支付成功!')
					    },
					    error: function (res) {
					    	reject()
					    	console.log(res)
					    	console.log('支付失败')
					    }
       				})       				
       			})
       		})
        },
        previewImage (current,list) {
       		this.$wechat.previewImage({
       			current: current, // 当前显示图片的http链接
   				urls: list // 需要预览的图片http链接列表
       		})
        },
        chooseImage (count,upload) {
        	count = count || 9
        	return new Promise((resolve,reject)=>{
        		this.$store.dispatch('getJssdkConfig',this.$wechat)
       			.then(jssdk=>{
	        		this.$wechat.chooseImage({
		        		count: count, // 默认9
						sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
						sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
				        success: (res) => {
					        this.images.localId = res.localIds;	
					        if(upload){
						        this.uploadImage().then(()=>{
						        	resolve(this.images.urls)
						        })
					        }else{
					        	resolve(res.localIds)
					        }
				      	}
				    });
			    })
        	})
        },
        uploadImage () {
        	let images = this.images
        	if (images.localId.length == 0) {
		      alert('请先选择图片');
		      return;
		    }
		    let i = 0, length = images.localId.length;
		    let $this = this
		    images.serverId = [];
		    images.urls = [];		    
		    
		    return new Promise((resolve,reject)=>{
		    	function upload() {
			      	$this.$wechat.uploadImage({
				        localId: images.localId[i],
				        success: (res) => {				          
				          	images.serverId.push(res.serverId);
				          
				          	$this.downloadImage(res.serverId).then(data=>{
					          	i++;
					          	$this.images.urls.push(data)
					          	if (i < length) {
						            upload();
						        }else{
						          	resolve()
						        }
				          	})				          
				        },
				        fail: (res) => {
				          	alert(JSON.stringify(res));
				          	reject();
				        }
			      	});
			    }
			    upload();	
	    	})
		    	    		    
        },
        uploadSingleImage (localId) {
        	return new Promise((resolve,reject)=>{
        		this.$wechat.uploadImage({
			        localId: localId,
			        success: (res) => {
			          resolve(res.serverId)
			        },
			        fail: (res) => {
			          alert(JSON.stringify(res));
			        }
	        	})
        	})        	
        },
        //下载微信多媒体文件，把media_id转url
        downloadImage (serverId) {        	
        	return new Promise((resolve,reject)=>{
        		this.$rest('/sapi/users/wx_upload_image').post({serverId:serverId})
	        	.success(response=>{
	        		resolve(response.data[0])
	        	}).error(response=>{
	        		reject()
	        		alert(response.body.message||'下载失败')
	        	})    
        	})
    		    	 	
        },
        getlocalImageData (localId) {
        	return new Promise((resolve,reject)=>{
        		this.$wechat.getLocalImgData({
					localId: localId, // 图片的localID
					success: function (res) {
						resolve(res.localData) 	//localData是图片的base64数据，可以用img标签显示
					},
					error: function (res) {
						reject(res)
					}
				});
        	})        	
        },
        startRecord () {
        	return new Promise((resolve,reject)=>{
        		this.$wechat.startRecord({
	        		cancel: function () {
	        			reject()
	        			alert('用户拒绝授权录音！')
	        		},
	        		success: function () {
	        			resolve()
	        		}
	        	})
        	})        	
        },
        onVoiceRecordEnd () {
        	return new Promise((resolve,reject)=>{
        		this.$wechat.onVoiceRecordEnd({
					// 录音时间超过一分钟没有停止的时候会执行 complete 回调
					complete: (res) => {	
						this.uploadVoice(res.localId)
    					.then(data=>{
    						resolve(data)
    					},response=>{
    						alert(JSON.stringify(response))
    						reject(response)
    					})
					}
				});
        	})
        	
        },
        stopRecord () {
        	return new Promise((resolve,reject)=>{
        		this.$wechat.stopRecord({
        			success: (res) => {
//      				resolve(res.localId)        				
//  					resolve(res.localId)     
    					this.uploadVoice(res.localId)
    					.then(data=>{
    						resolve(data)
    					},response=>{
    						reject(response)
    					})
        			},
        			fail: function (res) {
        				reject(res)
        				alert(JSON.stringify(res))
        			}
        		})
        	})
        },
        uploadVoice (localId) {
        	return new Promise((resolve,reject)=>{
        		this.$wechat.uploadVoice({
			      localId: localId,
			      success: (res) => {		        
//			        resolve(res.serverId)
			        this.downloadWXFile(res.serverId,'voice')
			        .then(data=>{
			        	resolve(data)
			        },res=>{
			        	reject(res)
			        })
			      },
			      fail: function (res) {
			      	reject(res)
			      }
			    })
        	})        	
        },
        downloadVoice (serverId) {
        	return new Promise((resolve,reject)=>{
	    		this.$wechat.downloadVoice({
			    	serverId: serverId,
			      	success: function (res) {			        
			        	resolve(res.localId)
			      	},
			      	fail: function (res) {
			      		reject(res)
			      	}
			    });
		    })
        },
        downloadWXFile (media_id,type) {
        	let params = {
        		msg_type: type,
        		media_id: media_id
        	}
        	return new Promise((resolve,reject)=>{
        		this.$rest('common/wx_download_file')
	        	.post(params)
	        	.success(response=>{
//	        		alert(JSON.stringify(response.data[0]))
	        		resolve(response.data[0])
	        	}).error(response=>{
	        		alert(response.body.message||'获取微信多媒体文件失败！')
	        		reject(response)
	        	})
        	})        	
        },
        playVoice (localId) {
        	if(!localId){
        		alert('音频Id错误！')
        		return 
        	}
        	this.$wechat.playVoice({
		      localId: localId
		    });
        },
        stopVoice (localId){
        	if(!localId){
        		alert('音频Id错误！')
        		return 
        	}
        	this.$wechat.stopVoice({
		      localId: localId
		    });
        },
        onVoicePlayEnd (localId) {
        	return new Promise((resolve,reject)=>{
        		this.$wechat.onVoicePlayEnd({
        			success: function (res) {
						resolve()
					}
        		})
        	})
        }
    }
}


// WEBPACK FOOTER //
// ./src/libs/wxjssdk.mixin.js